import ErrorMessage from "components/ErrorMessage";
import { useForm } from "react-hook-form";
import { apiPost } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";

const AddBackgroundCheckPricing = ({ setShowModal, getAllBackgroundCheckPricing }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const notification = useToastContext();

  const handleSubmitForm = async (data) => {
    try {
      data.name = data?.name?.trim();
      data.price = Number(data?.price);
      const path = apiPath.getBackgroundCheckPricing;
      const result = await apiPost(path, data);
      if (result?.data?.success === true) {
        notification.success(result?.data?.message);
        getAllBackgroundCheckPricing();
        setShowModal(false);
      } else {
        notification.error(result?.data?.message);
      }
    } catch (error) {
      console.log("error:", error.message);
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <form onSubmit={handleSubmit(handleSubmitForm)} method="post">
          <div className="relative w-auto my-6 mx-auto max-w-3xl">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("ADD_BACKGROUND_CHECK_PRICING")}</h3>
                <button
                  type="button"
                  className="ml-auto flex items-center justify-center text-black border-2 rounded-full h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => setShowModal(false)}
                >
                  <span className="text-[#B8BBBF] text-4xl">×</span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-1">
                  <div className="w-full">
                    <div className="w-full">
                      {/* Check Name */}
                      <div className="relative z-0 mb-6 w-full">
                        <input
                          type="text"
                          name="name"
                          id="name"
                          autoFocus
                          className="py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 peer"
                          placeholder=" "
                          maxLength={100}
                          {...register("name", {
                            required: "Please enter check name.",
                            minLength: {
                              value: 2,
                              message: "Minimum length must be 2.",
                            },
                            maxLength: {
                              value: 100,
                              message: "Maximum character can be 100.",
                            },
                          })}
                        />
                        <label
                          htmlFor="name"
                          className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                          {t("CHECK_NAME")}
                          <span className="text-red-500">*</span>
                        </label>
                        <ErrorMessage message={errors?.name?.message} />
                      </div>

                      {/* Price */}
                      <div className="relative z-0 mb-6 w-full">
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          name="price"
                          id="price"
                          className="py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 peer"
                          placeholder=" "
                          {...register("price", {
                            required: "Please enter price.",
                            min: {
                              value: 0,
                              message: "Price cannot be negative.",
                            },
                            validate: (value) =>
                              !isNaN(value) || "Please enter a valid price.",
                          })}
                        />
                        <label
                          htmlFor="price"
                          className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                          {t("PRICE")} ($)
                          <span className="text-red-500">*</span>
                        </label>
                        <ErrorMessage message={errors?.price?.message} />
                      </div>
                    </div>
                  </div>
                  <div />
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button
                  className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6 ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => setShowModal(false)}
                >
                  {t("O_BACK")}
                </button>
                <button
                  className="bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="submit"
                >
                  {t("O_ADD")}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default AddBackgroundCheckPricing;